import React, { memo } from 'react'
import Select, { Props as SelectProps } from 'react-select'
import styled from 'styled-components'

import { SelectOptionsWrapper } from './style'
import theme from 'vars/theme'
import { compareValue } from 'utils/commonFunctions'

const StyledSelect = styled(Select)`
  .mono-select__control {
    background-color: white;
    border: 1px solid #cccccc;
  }

  .mono-select__menu {
    background-color: white;
    color: #505155;
    .mono-select__option {
      color: #505155;
    }

    .mono-select__option--is-focused {
      background-color: rgba(77, 79, 83, 0.2);
    }

    .mono-select__option--is-selected {
      color: white;
      background-color: #505155;
    }
  }

  .mono-select__single-value {
    color: #505155;
  }

  .mono-select__indicator > svg {
    fill: ${theme.blueMedium5};
  }
`

interface OptionType {
  label: string;
  value: string;
}

interface Props extends Omit<SelectProps<OptionType, false>, 'value'> {
  width?: string;
  className?: string;
  style?: React.CSSProperties;
  hasClass?: boolean;
  color?: string;
  isError?: boolean;
  label?: string;
  required?: boolean;
  value: string | number;
  csvUploadId?: string;
}

const CustomSelect: React.FC<Props> = (props) => {
  const {
    width,
    className,
    style,
    options,
    placeholder,
    hasClass,
    name,
    color,
    isSearchable,
    isError,
    isDisabled,
    onChange,
    value,
    csvUploadId,
  } = props

  const valueSelect = React.useMemo(() => {
    if (!options) return null;

    return options.find((option: OptionType) => compareValue(option.value, value));
  }, [options, value]);

  return (
    <div className="d-flex flex-shrink-0" style={{ width }} data-csv-upload-id={csvUploadId}>
      <div className="flex-column align-items-start w-100">
        <SelectOptionsWrapper
          width={width}
          className={className}
          style={style}
          color={color}
          isError={isError}
          data-csv-upload-id={csvUploadId ? `${csvUploadId}-options` : undefined}
        >
          <StyledSelect
            className={hasClass ? 'ml-1' : ''}
            classNamePrefix="mono-select"
            isClearable={false}
            name={name}
            options={options}
            value={valueSelect}
            placeholder={placeholder}
            onChange={onChange}
            isSearchable={isSearchable}
            isDisabled={isDisabled}
            menuPlacement="auto"
            noOptionsMessage={() => '選択値なし'}
            data-csv-upload-id={csvUploadId ? `${csvUploadId}-option-list` : undefined}
          />
        </SelectOptionsWrapper>
      </div>
    </div>
  )
}

export default memo(CustomSelect)
